export const MIXED_DATA_ACCESS = -1;
export function fromAccessRequests(accessRequests) {
    const idToRequestData = accessRequests.reduce((acc, request) => {
        const prev = acc.get(request.getAssigneeId()) ?? [];
        acc.set(request.getAssigneeId(), [...prev, request]);
        return acc;
    }, new Map());
    return [...idToRequestData.values()].map((requests) => {
        const accesses = new Set(requests.map((r) => r.dataAccess));
        return {
            assignee: requests[0].getAssignee(),
            // if requests is created from client actions, their recursive value is always same for same assignee
            // if its from backend data - its always false
            recursive: requests[0].recursive,
            dataAccess: accesses.size > 1 ? MIXED_DATA_ACCESS : requests[0].dataAccess,
            message: requests[0].accessGrantMessage,
        };
    });
}
